```vue
<template>
  <div id="app">
    <div
      v-if="
        isMobile || currentRouteName == 'info' || currentRouteName == 'promo'
      "
    >
      <div v-if="isLoading">
        <Loader :isLoading="isLoading" />
      </div>

      <transition :name="transitionName">
        <router-view />
      </transition>
    </div>

    <div v-else class="desktop-wrapper">
      <!-- BACKGROUND -->
      <div
        class="img-background"
        :style="{ backgroundImage: `url(${backgroundImage})` }"
      >
        <!-- LANGUAGE DROPDOWN -->
        <b-dropdown
          class="language-dropdown"
          toggle-class="language-toggle"
          variant="light"
          right
          no-caret
        >
          <template #button-content>
            <b-icon icon="globe" aria-hidden="true" />
            <span class="sr-only">{{ copy.language }}</span>
          </template>
          <b-dropdown-item
            v-for="option in languageOptions"
            :key="option.value"
            :active="language === option.value"
            @click="language = option.value"
          >
            {{ option.text }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import { mapState } from "vuex";

export default {
  components: {
    Loader,
  },

  data() {
    return {
      isMobile: false,

      transitionName: "",

      language: "km",

      languageOptions: [
        {
          value: "en",
          text: "English",
        },
        // {
        //   value: "id",
        //   text: "Indonesia",
        // },
        {
          value: "km",
          text: "កម្ពុជា",
        },
      ],

      translations: {
        en: {
          language: "Language",
        },

        id: {
          language: "Bahasa",
        },

        km: {
          language: "ភាសា",
        },
      },
    };
  },

  computed: {
    ...mapState(["isLoading"]),

    currentRouteName() {
      return this.$route.name;
    },

    copy() {
      return (
        this.translations[this.language] ||
        this.translations.km ||
        this.translations.en
      );
    },

    backgroundImage() {
      switch (this.language) {
        case "id":
          return require("@/assets/play-phone-2.png");

        case "en":
          return require("@/assets/play-phone-en.png");

        case "km":
        default:
          return require("@/assets/play-phone-kh.png");
      }
    },
  },

  watch: {
    language(value) {
      try {
        localStorage.setItem("loginLanguage", value);
      } catch (e) {
        console.warn("localStorage unavailable", e);
      }

      document.documentElement.lang = value;
    },
  },

  beforeMount() {
    this.$store.state.isLoading = false;

    let savedLanguage = null;

    try {
      savedLanguage = localStorage.getItem("loginLanguage");
    } catch (e) {
      console.warn("localStorage unavailable", e);
    }

    if (savedLanguage && this.translations[savedLanguage]) {
      this.language = savedLanguage;
    }

    document.documentElement.lang = this.language;

    this.handleResize();
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    });
  },

  methods: {
    handleResize() {
      const userAgent = navigator.userAgent || "";

      const isIPad =
        /iPad/i.test(userAgent) ||
        (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1);

      this.isMobile = this.$isMobile() || isIPad;
    },
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style>
html,
body {
  min-height: 100vh;
}

.desktop-wrapper {
  position: relative;
  min-height: 100vh;
}

.img-background {
  position: relative;
  background-color: rgb(241, 239, 239);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
}
.language-dropdown {
  position: absolute !important;
  top: 20px !important;
  right: 20px !important;
  left: auto !important;
  z-index: 9999;
}
.language-dropdown .language-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  padding: 0;
  border-radius: 50%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.b-sidebar {
  background: linear-gradient(90deg, #d82827 0%, #d82827 57.29%) !important;
}

.btn-primary {
  color: #222 !important;
  background-color: #fff !important;
  border-color: #fff !important;
}

.btn-success {
  color: #fff !important;
  background-color: #33c900 !important;
  border-color: #24b300 !important;
  border-width: 5px !important;
}

.btn-warning {
  color: #000 !important;
  background: #fecf2f;
  border-color: transparent !important;
}

.pt-6 {
  padding-top: 6rem !important;
}

main {
  min-height: 100%;
  display: grid;
  grid-template: "main";
  flex: 1;
  background-color: white;
  position: relative;
  z-index: 0;
  overflow-x: hidden;
}

main > * {
  grid-area: main;
  background-color: white;
  position: relative;
}

main > :first-child {
  z-index: 1;
}

/* TRANSITIONS */

.next-leave-to {
  animation: leaveToLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

.next-enter-to {
  animation: enterFromRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
  top: 0;
}

.prev-leave-to {
  animation: leaveToRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
  top: 0;
}

.prev-enter-to {
  animation: enterFromLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

@keyframes leaveToLeft {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-100%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromLeft {
  from {
    transform: translateX(-100%);
    filter: brightness(0.5);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}
</style>
```
